<template>
  <div id="app">
    <div v-if="onLine">
      <v-tour
        v-for="tour in tours"
        :key="tour.id"
        :name="tour.name"
        :steps="tour.data"
        :callbacks="vueToursCallbacks(tour.id)"
      ></v-tour>
      <!-- <v-tour name="myMovieAddTour" :steps="stepsMovieAdd"></v-tour>
          <v-tour name="myScheduleDragAndDropTour1" :steps="stepsDragAndDropSchedule1"></v-tour>
          <v-tour name="myScheduleDragAndDropTour2" :steps="stepsDragAndDropSchedule2"></v-tour>
          <v-tour name="myScheduleDragAndDropTour3" :steps="stepsDragAndDropSchedule3"></v-tour> -->
      <!-- <v-tour name="myScheduleTour" :steps="steps"></v-tour> -->
      <!-- ADD A "BLUR" CLASS TO "MAIN" TAG WHENEVER LOADER IS TRUE -->
      <!-- ADD A "BLUR" CLASS TO "MAIN" TAG WHENEVER MODAL IS TRUE -->
      <!-- <Modal /> -->
      <router-view />
    </div>
    <div v-else>
      <connectionLost />
    </div>
  </div>
</template>
<script>
import Loader from "@/components/Partials/loader.vue";
import connectionLost from "@/components/Partials/connection-lost.vue";
import Modal from "@/components/Partials/globalModal.vue";
import Tooltip from "@/components/UIElements/Tooltip.vue";
import SetupService from "@/services/SetupService.js";
import { getTours, setTourComplete } from "@/helper/tours.js";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "App",
  components: {
    Loader,
    Modal,
    connectionLost,
    Tooltip
  },
  data() {
    return {
      onLine: navigator.onLine,
      tours: [],
      vueToursCallbacks: id => ({
        onFinish: () => this.handleWalkThroughFinished(id),
        onSkip: () => this.handleWalkThroughFinished(id)
      })
    };
  },
  head: {
    title() {
      return `Testing`;
    },
    meta: [
      {
        name: "description",
        content() {
          return `Here is the description`;
        }
      }
    ]
  },
  beforeRouteEnter(to, from, next) {
    // return store.fetchSpecial(to.params.slug).then(next)
    next();
  },
  watch: {
    "$store.getters.isGogoCinema": function(newVal) {
      const root = document.documentElement;
      if (newVal == "Y" && false) {
        // root.style.setProperty("--blue", "#dc3545");
        // root.style.setProperty("--scrollBarBlue", "#ce0c1e");
        // root.style.setProperty("--Darkblue", "#dc3545");
        // root.style.setProperty("--navLinkBlue", "#ce0c1e");
        // root.style.setProperty("--multiselectTag", "#dc3545");
        // root.style.setProperty("--lightblue", "#f15a69");
      } else {
        // root.style.setProperty("--blue", "#3876d2");
        // root.style.setProperty("--scrollBarBlue", "#1c498c");
        // root.style.setProperty("--Darkblue", "#131923");
        // root.style.setProperty("--navLinkBlue", "#1c498c");
        // root.style.setProperty("--multiselectTag", "#2f75dcde");
        // root.style.setProperty("--lightblue", "#75a7f0");
      }
    }
  },
  beforeMount() {
    this.getSetupStatus();
    this.$store.dispatch("fetchGlobalOptions");
    this.$store.dispatch("fetchHealthMeta");
    this.$store.dispatch("fetchOrgDetails");
    if (this.$cookie.get("BRHSID")) {
      try {
        this._GetGlobalOptions();
      } catch (error) {
        this.$toasted.show("Error while fetching global options " + error);
      }
      if (this.secureStore.get("USINFO")) {
        let cinema_id = this.secureStore.get("USINFO").cinema_id;
        let user_id = this.secureStore.get("USINFO").user_id;

        let urlPath = window.location.hash;
        if (
          !urlPath.includes("/pos-booking") &&
          !urlPath.includes("/box-office-fnb") &&
          !urlPath.includes("/pos-fnb") &&
          !urlPath.includes("/pos-lock-screen") &&
          !urlPath.includes("/pos-login") &&
          !urlPath.includes("/pos-fnb-login")
        ) {
          this.$store.dispatch("fetchUserHotPickModules");
          this.$store.dispatch("setDropdownCinema"); // PRESET DROPWDOWN CINEMA IN REPORT IF ONLY ONE CINEMA
        }
        // let username = this.secureStore.get("USINFO").username;
        // let cinema_id = this.secureStore.get("USINFO").role_id;
        // this.$store.dispatch("setLanguages", null);
        // this.$store.dispatch("setContentLanguages", null);
        // this.$store.dispatch("setMoviePosters", null);
        let guest_id = window.localStorage.getItem("guest_user_id");
        if (!guest_id || isNaN(parseInt(guest_id))) {
          guest_id = Math.floor(100000000 + Math.random() * 900000000);
          window.localStorage.setItem("guest_user_id", guest_id);
        }
        this.$store.dispatch("onSetLog", {
          cinema_id: cinema_id,
          user_id: user_id
        });
      }
      // this.$store.dispatch("setIpDetails",);
    }
    this.tours = getTours(true);
  },
  mounted() {
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
    if (window.innerWidth < 768) {
      this.setIsMobile(true);
    } else {
      this.setIsMobile(false);
    }
    window.addEventListener("resize", () => {
      if (window.innerWidth < 768) {
        this.setIsMobile(true);
      } else {
        this.setIsMobile(false);
      }
    });
  },
  destroyed() {
    window.removeEventListener("resize");
  },
  methods: {
    updateOnlineStatus(e) {
      const { type } = e;
      this.onLine = type === "online";
      if (this.onLine) {
        document.getElementById("app").style.background = "#3876d2";
      } else {
        document.getElementById("app").style.background = "#fff";
      }
    },
    handleWalkThroughFinished: function(id) {
      setTourComplete(id);
      this.tours = getTours(true);
    },
    getSetupStatus: function() {
      SetupService.SetupStatus()
        .then(response => {
          const { data } = response;
          if (data && data.status && data.isSetupAllowed) {
            console.log("data.status :", data.status);
            console.log("data.route :", data.route);
            this.$router.replace({
              path: data.route
            });
          }
        })
        .catch(err => {
          // this.$router.push({
          //   name: "Error404"
          // });
        });
    },
    ...mapActions(["setIsMobile"])
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue